<div class="row cliente-central-compra-v1">
    <div class="col-12">
        <div class="row container-header">
            <div class="col-12">
                <label for="clienteCentralCompra" class="col-form-label">Central de Compra</label>
                <!-- É uma Central de Compra -->
                <div *ngIf="isCentralCompra">
                    <span class="badge badge-primary">Este Cliente é uma Central de Compra</span>
                </div>

                <!-- Não é uma Central de Compra -->
                <div *ngIf="!isCentralCompra">
                    <sgt-typeahead-cliente [(ngModel)]="entity" name="clienteCentralCompra" id="clienteCentralCompra"
                        #clienteCentralCompra="ngModel" [ngControl]="clienteCentralCompra"
                        [somenteCentralDeCompraV1]="true"
                        [idClienteAtual]="idCliente"
                        (typeaheadChange)="onClienteCentralCompra($event)">
                    </sgt-typeahead-cliente>
                    <p style="margin-bottom:0px;" class="form-text text-muted">Selecione a Central de Compra se este cliente possuir uma para vincular os cadastros</p>
                </div>
            </div>
        </div>

        <div class="card card-clientes-vinculados" *ngIf="isShowClientesVinculados()">
            <div class="card-header">
                <button type="button" class="btn btn-link" (click)="toggleClientesVinculados()">
                    <i *ngIf="!isCollapsedIn" class="fas fa-caret-down" aria-hidden="true"></i>
                    <i *ngIf="isCollapsedIn" class="fas fa-caret-up" aria-hidden="true"></i>
                    Ver clientes vinculados a esta Central de Compra
                </button>

                <span class="badge badge-secondary badge-qtd-clientes-vinculados">
                    {{clientesVinculados?.length}} cliente(s)
                </span>
            </div>
            <div class="container-clientes-vinculados" #containerClienteVinculados>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th class="col-options"></th>
                                <th class="col-codigo-integracao-erp">Código ERP</th>
                                <th class="col-nome">Nome</th>
                                <th class="col-cnpj-cpf text-center">CNPJ/CPF</th>
                                <th class="col-is-central-compra text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let clienteVinculado of clientesVinculados; let i = index">
                                <td class="col-options text-center">
                                    <a (click)="open(clienteVinculado)" title="Abrir Cliente">
                                        <i class="fas fa-search" aria-hidden="true"></i>
                                    </a>
                                    <a (click)="desvincularCentralCompra(clienteVinculado)" title="Desvincular Cliente" *ngIf="!clienteVinculado.isCentralCompra">
                                        <i class="fas fa-unlink" aria-hidden="true"></i>
                                    </a>
                                </td>
                                <td class="col-codigo-integracao-erp">{{clienteVinculado.codigoIntegracaoErp}}</td>
                                <td class="col-nome">{{clienteVinculado.nome}}</td>
                                <td class="col-cnpj-cpf text-center">{{clienteVinculado.cnpjCpf}}</td>
                                <td class="col-is-central-compra text-center">
                                    <span *ngIf="clienteVinculado.isCentralCompra" class="badge badge-primary">
                                        Central de Compra
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
